(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/overview-hero/assets/javascripts/common/registration.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/overview-hero/assets/javascripts/common/registration.js');

'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _ReactRedux = ReactRedux,
  useDispatch = _ReactRedux.useDispatch;
const _ReactRouterDOM = ReactRouterDOM,
  useHistory = _ReactRouterDOM.useHistory,
  useParams = _ReactRouterDOM.useParams;
const Button = svs.ui.ReactButton;
const logger = svs.core.log.getLogger('marketplace-competition:overview-hero');
const putParticipation = svs.components.marketplaceCompetition.services.actions.playerCompetitionActions.putParticipation;
const showDialogAction = svs.components.marketplaceCompetition.services.actions.dialogActions.showDialogAction;
const useCompetitionType = svs.components.marketplaceCompetition.services.hooks.useCompetitionType;
const resolveCompetitionName = svs.components.marketplaceCompetition.helpers.resolveCompetitionName;
const preventDoubleClick = svs.components.lbUtils.preventDoubleClick;
const CompetitionType = svs.components.marketplaceCompetition.constants.CompetitionType;
const processErrorCode = svs.components.marketplaceShared.competitionErrorCodes.processErrorCode;
const Registration = _ref => {
  let competition = _ref.competition;
  const dispatch = useDispatch();
  const history = useHistory();
  const params = useParams();
  const compType = useCompetitionType(competition.id);
  const compName = resolveCompetitionName(competition);
  const _svs$tipsen$data$comp = svs.tipsen.data.competition,
    tipsSmRulesDocumentId = _svs$tipsen$data$comp.tipsSmRulesDocumentId,
    tipsEmRulesDocumentId = _svs$tipsen$data$comp.tipsEmRulesDocumentId,
    policyPersonalData = _svs$tipsen$data$comp.policyPersonalData;
  const rulesDocumentId = compType === CompetitionType.TipsEM ? tipsEmRulesDocumentId : tipsSmRulesDocumentId;
  const initPutParticipation = async () => {
    try {
      await dispatch(putParticipation({
        competitionId: competition.id
      })).unwrap();
      svs.components.analytics.trackEvent({
        category: compType,
        action: 'joined competition',
        opt_label: 'Individuellt'
      });
      dispatch(showDialogAction({
        title: "Du \xE4r anm\xE4ld till ".concat(compName, "."),
        icon: 'exclamation-sign',
        buttons: [{
          text: 'Okej'
        }]
      }));
    } catch (err) {
      logger.info("N\xE5got gick fel vid anm\xE4lan till t\xE4vlingen (id: ".concat(competition.id, "): ").concat(err));
      const _processErrorCode = processErrorCode(err),
        errorTitle = _processErrorCode.errorTitle,
        errorMessage = _processErrorCode.errorMessage;
      dispatch(showDialogAction({
        title: errorTitle,
        text: errorMessage,
        icon: 'exclamation-sign',
        type: 'error',
        buttons: [{
          text: 'Okej'
        }]
      }));
    }
  };
  const validateDocuments = () => {
    const notValid = Object.entries({
      compName,
      rulesDocumentId,
      competitionId: competition.id,
      policyPersonalData
    }).filter(_ref2 => {
      let _ref3 = _slicedToArray(_ref2, 2),
        v = _ref3[1];
      return !v;
    }).map(_ref4 => {
      let _ref5 = _slicedToArray(_ref4, 1),
        k = _ref5[0];
      return k;
    });
    if (notValid.length) {
      const logMessage = "Missing data: ".concat(notValid.join(', '));
      logger.info(logMessage);
    }
  };
  const handleRegisterUser = () => {
    validateDocuments();
    dispatch(showDialogAction({
      title: "Bekr\xE4fta att du vill g\xE5 med i ".concat(compName),
      text: "Genom att g\xE5 med i ".concat(compName, " godk\xE4nner du <br/> <a target=\"_blank\" rel='noreferrer' href=\"/dokument/").concat(rulesDocumentId, "\" target=\"_blank\">regler och villkor f\xF6r ").concat(compName, "</a>\n              <br/><br/>Information g\xE4llande <a target=\"_blank\" rel='noreferrer' href=\"/dokument/").concat(policyPersonalData, "\" target=\"_blank\">behandling av personuppgifter</a>"),
      icon: 'exclamation-sign',
      buttons: [{
        text: 'Avbryt'
      }, {
        text: 'Gå med',
        callback: initPutParticipation
      }]
    }));
  };
  const handleRegisterTeam = () => {
    history.push("/tavlingar/".concat(params.competitionName, "/skapa-lag"));
  };
  return React.createElement("div", {
    className: "overview-hero-button-container dual-buttons"
  }, React.createElement(Button, {
    "aria-label": "Anm\xE4l dig individuellt",
    className: "button-150 qa-competition-overview-hero-register-user-button",
    onClick: preventDoubleClick(handleRegisterUser)
  }, "Individuellt"), React.createElement(Button, {
    "aria-label": "Anm\xE4l ett lag",
    className: "button-150 qa-competition-overview-hero-register-team-button",
    href: "/tavlingar/".concat(params.competitionName, "/skapa-lag"),
    onClick: e => {
      e.preventDefault();
      e.stopPropagation();
      e.nativeEvent.stopImmediatePropagation();
      preventDoubleClick(handleRegisterTeam());
    }
  }, "Lag"));
};
setGlobal('svs.components.marketplaceCompetition.overviewHero.common.Registration', Registration);

 })(window);